<div class="flex items-baseline flex-wrap text-[20px] mt-4 mb-4 ml-2">
    <ng-container *ngFor="let icon of visibleIcons">
      <img
        [src]="icon.path"
        [alt]="icon.tooltip"
        class="w-6 h-6 mx-1"
        [title]="icon.tooltip"
      />
    </ng-container>

    <!-- ellipsis for extra methods -->
    <ng-container *ngIf="overflowTooltips.length">
      <span
        class="mx-1 cursor-pointer font-bold"
        [title]="overflowTooltips.join(', ')">…</span>
    </ng-container>
  </div>
